import TagManager from "react-gtm-module";
export const tagManagerEvents = (eventName: string, utm_source: string) => {
  // console.warn("this is event name", eventName, "utm source", utm_source);
  const tagManagerArgs = {
    dataLayer: {
      event: eventName,
      utm_source: utm_source,
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const tagManagerParamsEvents = (eventName: string, data: any) => {
  const tagManagerParamsArgs = {
    dataLayer: {
      event: eventName,
      ...data,
    },
  };

  TagManager.dataLayer(tagManagerParamsArgs);
};

export const AwarenessTagManagerEvents = (data:any) => {
  const tagManagerArgs = {
    dataLayer: data,
  };
  TagManager.dataLayer(tagManagerArgs);
};
